// extracted by mini-css-extract-plugin
module.exports = {"link":"Developers_link__376st","sections":"Developers_sections__3tpTX","name":"Developers_name__2J-rA","role":"Developers_role__2RLE2","text":"Developers_text__293Ah"};